import { create } from "zustand";
import { persist } from "zustand/middleware";
import type { Product } from "../types/Product";

const MAX_RECENT_PRODUCTS = 10;

interface RecentlyViewedState {
  products: Product[];
  addProduct: (product: Product) => void;
}

export const useRecentlyViewedStore = create<RecentlyViewedState>()(
  persist(
    (set, get) => ({
      products: [],

      addProduct: (product) => {
        const filtered = get().products.filter((p) => p.id !== product.id);
        set({ products: [product, ...filtered].slice(0, MAX_RECENT_PRODUCTS) });
      },
    }),
    { name: "recentlyViewedProducts" }
  )
);
